"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _wrapperContext = _interopRequireDefault(require("../context/wrapper-context"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  /* The padding, margin keeps the ripple effect nice */\n  margin: ", " !important;\n  padding: ", " !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: #171818;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCloseIcon = (0, _styledComponents["default"])(_Close["default"])(_templateObject());
var StyledIconButton = (0, _styledComponents["default"])(_IconButton["default"])(_templateObject2(), function (props) {
  return "".concat(props.theme.spacing(2), "px");
}, function (props) {
  return "".concat(props.theme.spacing(3), "px");
});

var CloseFocusButton = function CloseFocusButton() {
  var wrapperContext = (0, _react.useContext)(_wrapperContext["default"]);
  return /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
    disableTouchRipple: true,
    onClick: wrapperContext.closeFocusView,
    tag: "close focus screen",
    dataElementLocation: _taggingHelper.DataElementLocations.HEADER,
    dataElementLabel: "navigation-close-button",
    dataElementId: "navigation-close-button"
  }, /*#__PURE__*/_react["default"].createElement(StyledCloseIcon, null));
};

var _default = CloseFocusButton;
exports["default"] = _default;